import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR
  // const logo = '/logo/logo_single.svg';

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" preserveAspectRatio="xMidYMid meet">
        <path
          fill={PRIMARY_MAIN}
          d="M5.274 6.915q.301 0 .576.086a16 16 0 0 1 2.283-2.1a1.95 1.95 0 0 1 .048-1.076A14.4 14.4 0 0 0 5.17 2.171a9.3 9.3 0 0 0-2.582 2.381c.519.92 1.136 1.777 1.838 2.557c.256-.124.543-.194.848-.194M3.316 8.872c0-.275.058-.537.159-.773A16 16 0 0 1 1.78 5.87a9.2 9.2 0 0 0-.98 4.131a9.16 9.16 0 0 0 1.295 4.705a15.6 15.6 0 0 1 1.62-4.652a1.95 1.95 0 0 1-.399-1.182m6.72-6.383c.517 0 .985.201 1.336.529a15.6 15.6 0 0 1 3.215-.992A9.15 9.15 0 0 0 10 .8a9.2 9.2 0 0 0-3.236.588a16 16 0 0 1 2.277 1.375c.292-.174.631-.274.995-.274m2.926 9.219a1.9 1.9 0 0 1 .509-.656a14.3 14.3 0 0 0-2.672-4.803a1.96 1.96 0 0 1-1.901-.211a14.3 14.3 0 0 0-1.964 1.803a1.93 1.93 0 0 1 .207 1.617a14.25 14.25 0 0 0 5.821 2.25m2.539 2.643a16 16 0 0 1-.081 3.082a9.2 9.2 0 0 0 3.347-4.639a15.4 15.4 0 0 1-2.181.365a1.96 1.96 0 0 1-1.085 1.192m-2.997-1.327a15.6 15.6 0 0 1-6.21-2.484a1.95 1.95 0 0 1-1.423.248a14.2 14.2 0 0 0-1.599 5.484a9.2 9.2 0 0 0 3.145 2.205a15.66 15.66 0 0 1 6.087-5.453m3.672-9.843a14.3 14.3 0 0 0-4.193 1.068a1.95 1.95 0 0 1-.191 1.056a15.7 15.7 0 0 1 2.969 5.291a1.96 1.96 0 0 1 1.77 1.195c.886-.09 1.748-.26 2.578-.504a9.18 9.18 0 0 0-2.933-8.106m-2.687 10.888a14.3 14.3 0 0 0-5.723 4.856A9.2 9.2 0 0 0 10 19.2a9.2 9.2 0 0 0 3.882-.859c.19-.928.29-1.887.29-2.869q-.001-.533-.043-1.055a1.9 1.9 0 0 1-.64-.348"
        />
      </svg>

      {/* <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>

        <g fill={PRIMARY_MAIN} fillRule="evenodd" stroke="none" strokeWidth="1">
          <path
            fill="url(#BG1)"
            d="M183.168 285.573l-2.918 5.298-2.973 5.363-2.846 5.095-2.274 4.043-2.186 3.857-2.506 4.383-1.6 2.774-2.294 3.939-1.099 1.869-1.416 2.388-1.025 1.713-1.317 2.18-.95 1.558-1.514 2.447-.866 1.38-.833 1.312-.802 1.246-.77 1.18-.739 1.111-.935 1.38-.664.956-.425.6-.41.572-.59.8-.376.497-.537.69-.171.214c-10.76 13.37-22.496 23.493-36.93 29.334-30.346 14.262-68.07 14.929-97.202-2.704l72.347-124.682 2.8-1.72c49.257-29.326 73.08 1.117 94.02 40.927z"
          />
          <path
            fill="url(#BG2)"
            d="M444.31 229.726c-46.27-80.956-94.1-157.228-149.043-45.344-7.516 14.384-12.995 42.337-25.267 42.337v-.142c-12.272 0-17.75-27.953-25.265-42.337C189.79 72.356 141.96 148.628 95.69 229.584c-3.483 6.106-6.828 11.932-9.69 16.996 106.038-67.127 97.11 135.667 184 137.278V384c86.891-1.611 77.962-204.405 184-137.28-2.86-5.062-6.206-10.888-9.69-16.994"
          />
          <path
            fill="url(#BG3)"
            d="M450 384c26.509 0 48-21.491 48-48s-21.491-48-48-48-48 21.491-48 48 21.491 48 48 48"
          />
        </g>
      </svg> */}
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
